import { Spin } from "antd";
import moment from "moment";
import { MdDelete } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { IoIosWarning } from "react-icons/io";
import ReactS3Client from "react-aws-s3-typescript";
import { FileUploader } from "react-drag-drop-files";
import { useForm, SubmitHandler } from "react-hook-form";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import Breadcrumb from "Components/Breadcrums";
import FormControl from "Components/FormControl";
import Imagepreview from "Components/ImagePreview";
import Upload from "Components/UploadDesign/upload";
import { showErrorAlert, showWarningAlert, Toast } from "Util/Alerts";

import { config } from "../../../s3config";
import { breadcrumbItems } from "./Constant";
import { giveawayproductsInputs } from "./Types";
import {
    add_giveawayproducts,
    update_giveawayproducts,
    uploadImage,
} from "Services/Requests";
import Styles from "Styles/Styles.module.css";
import ReactQuill from "react-quill";

window.Buffer = window.Buffer || require("buffer").Buffer;

function Addgiveawayproducts() {
    const navigate = useNavigate();
    const fileTypes = ["JPG", "PNG", "JPEG"];
    const { type } = useParams();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [quillData, setQuillData] = useState("");

    const [giveawayproductsImg, setgiveawayproductsImg] = useState("");
    const [ErrorMsg, setErrorMsg] = useState<null | string>(null);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        resetField,
        reset,
        watch,
        setError,
    } = useForm<giveawayproductsInputs>();

    const handleChange = (files: any) => {
        setErrorMsg("");
        let maxSize = 2 * 1024 * 1024;
        if (files.size > maxSize) {
            alert("File size cannot be greater than 2 MB");
            return;
        }

        const timestamp = Date.now();
        const fileName = `${timestamp}`;

        setLoading(true);
        let formData = new FormData();
        formData.append("image", files);
        formData.append("folder", "giveawayProductImages");
        uploadImage(formData)
            .then((res: any) => {
                setValue("image_url", res.data?.image);
                setgiveawayproductsImg(res.data?.url);
                setLoading(false);
            })
            .catch((err: any) => {
                alert(err);
                setLoading(false);
            });
    };

    const onSubmit: SubmitHandler<giveawayproductsInputs> = async (data) => {
        if (!giveawayproductsImg) {
            setErrorMsg("Please Upload File");
            return;
        }
        if (quillData === "") {
            setErrorMsg("Description is required");
            return;
        }
        try {
            setLoading(true);
            let response;
            if (type === "edit") {
                response = await update_giveawayproducts(
                    location.state?.giveaway_product_id,
                    { ...data, description: quillData }
                );
            } else {
                response = await add_giveawayproducts({
                    ...data,
                    description: quillData,
                });
            }
            if (response?.data?.status === 1) {
                Toast(response?.data?.Message, "success");
                navigate(-1);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong, try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    const watchData = watch();

    useEffect(() => {
        if (type === "edit") {
            let formData = location.state;
            formData = {
                ...formData,

                image_url: String(formData.image_url).split("/")[
                    String(formData.image_url).split("/").length - 1
                ],
            };
            reset({ ...formData });
            setQuillData(formData.description);
            setgiveawayproductsImg(location.state?.image_url);
        }
    }, [type, location.state, reset]);
    const toolbarOptions = [
        [{ font: [] }], // Font family
        [{ size: [] }], // Font size
        ["bold", "italic", "underline", "strike"], // Text formatting
        [{ align: [] }], // Alignment
        [{ list: "ordered" }, { list: "bullet" }], // Lists

        [{ color: [] }, { background: [] }], // Text color and background color
    ];

    // Modules configuration
    const modules = {
        toolbar: {
            container: toolbarOptions,
            handlers: {
                // Custom handlers if needed
            },
        },
    };
    return (
        <div className={Styles["Add_form_wrapper"]}>
            <Imagepreview
                handleCancel={() => setIsModalVisible(false)}
                selectedImage={giveawayproductsImg}
                isModalVisible={isModalVisible}
                title="giveawayproducts"
            />
            <h3>
                <span style={{ textTransform: "capitalize" }}>{type}</span>{" "}
                Giveaway Products
            </h3>
            <Breadcrumb items={breadcrumbItems} type={type} />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={Styles["form"]}>
                    {/* <h4>giveawayproducts</h4> */}
                    <FormControl
                        key={"giveawayproducts Name"}
                        label={"Products Name"}
                        name={"giveaway_product_name"}
                        register={register}
                        errors={errors["giveaway_product_name"]}
                        requiredMessage={"this field is required"}
                        type={"text"}
                    />
                    {/* <FormControl
                        key={"Description"}
                        label={"Description"}
                        name={"description"}
                        register={register}
                        errors={errors["description"]}
                        requiredMessage={"this field is required"}
                        type={"textarea"}
                    /> */}

                    <div className={Styles["form_control"]}>
                        <label htmlFor="Photo">Photo</label>
                        <FileUploader
                            handleChange={handleChange}
                            name="file"
                            types={fileTypes}
                            children={Upload}
                        />
                        <span style={{ fontSize: "0.9rem" }}>
                            Upload an image with dimensions of 114x114
                        </span>
                        {giveawayproductsImg && (
                            <div className={Styles["remove_upload"]}>
                                <div onClick={() => setIsModalVisible(true)}>
                                    <img
                                        src={giveawayproductsImg}
                                        alt="giveawayproducts"
                                    />
                                </div>
                                <button
                                    onClick={() => {
                                        resetField("image_url");
                                        setgiveawayproductsImg("");
                                    }}>
                                    <MdDelete />
                                </button>
                            </div>
                        )}
                    </div>
                    <div
                        className={`${Styles["form_control_quill"]} quill_custom`}
                        style={{ gridColumn: "1/-1" }}>
                        <label htmlFor="Banner Name">Description *</label>
                        <ReactQuill
                            theme="snow"
                            value={quillData}
                            onChange={setQuillData}
                            modules={modules}
                            // theme="snow" // Use 'snow' theme
                        />
                    </div>

                    {ErrorMsg && (
                        <p className={Styles["Gen-erro_msg"]}>
                            <IoIosWarning /> {ErrorMsg}
                        </p>
                    )}
                </div>

                {loading ? (
                    <Spin size="default" />
                ) : (
                    <button>{type === "edit" ? "Update" : "Add"}</button>
                )}
            </form>
        </div>
    );
}

export default Addgiveawayproducts;
